"use strict";

import _ from "lodash";
import { Component, PropTypes } from "react";
import ComponentBase from ".\\ComponentBase";

const isObject = _.isObject;

/******************************************************************************
** FormComponentBase
*/

export default class FormComponentBase extends ComponentBase {

	static propTypes = {
		context: PropTypes.object,
		name: PropTypes.string.isRequired,
		};

	constructor(props) {
		super(props);
		if (isObject(props.context)) {
			this.state = Object.assign(this.state || {}, {
				clientId: props.context.getFormClientId() + "_" + props.name
			});
		}
	}

}



/** WEBPACK FOOTER **
 ** ./forms/FormComponentBase.jsx
 **/